import { MouseEvent } from "react";
import { Splitter, SplitterPanel } from "primereact/splitter";

import { themeClasses as T, C } from "sj-ui-toolkit/src/atlas/utils/themeClasses";

import LessonInfo from "./LessonInfo";
import Survey from "./Survey/Survey";

import S from "./_Lesson.module.scss";

interface LessonCoverPageProps {
  headerText: string;
  onSubmit: (
    rating: string | null,
    isExiting?: boolean,
    event?: MouseEvent<HTMLButtonElement>
  ) => void;
  description?: string;
  lessonType?: string;
  title?: string;
  difficulty?: string;
  // `level` is accepted (passed by the after-survey view) but forwarded as difficulty is not.
  level?: string;
  duration?: string | number;
  isAfterLessonSurvey: boolean;
  hasNextLesson?: boolean;
  isPathCompleted?: boolean;
}

const LessonCoverPage = ({
  headerText,
  onSubmit,
  description,
  lessonType,
  title,
  difficulty,
  duration,
  isAfterLessonSurvey,
  hasNextLesson,
  isPathCompleted,
}: LessonCoverPageProps) => {
  return (
    <Splitter className={C(T.splitterGap, "w-full h-full")} aria-label="Resize lesson panels">
      <SplitterPanel size={30} minSize={20} className={C("flex flex-col max-h-full", S.leftPanel)}>
        <section>
          <LessonInfo
            lessonType={lessonType}
            title={title}
            description={description}
            difficulty={difficulty}
            duration={duration}
          />
        </section>
      </SplitterPanel>
      <SplitterPanel className="max-h-full" size={70} minSize={40}>
        <Survey
          headerText={headerText}
          onSubmit={onSubmit}
          description={description}
          isAfterLessonSurvey={isAfterLessonSurvey}
          hasNextLesson={hasNextLesson}
          isPathCompleted={isPathCompleted}
        />
      </SplitterPanel>
    </Splitter>
  );
};

export default LessonCoverPage;
